"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const aspectRatio = require("aspect-ratio");
function calculateRatio(dimensions) {
    return aspectRatio(dimensions.width, dimensions.height);
}
exports.calculateRatio = calculateRatio;
//# sourceMappingURL=calculate-ratio.js.map